import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {ChangeEventHandler, useContext, useEffect, useState} from "react";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {LocalizedLanguages} from "./Localization";

interface IUpdateDialog {
    editLocalizedKey: string
    englishText: string
    language: string
    localizedText: string
    onClose: () => void
    project: string
}
export function UpdateTextDialog({editLocalizedKey, englishText, language, localizedText, onClose, project}: IUpdateDialog) {
    const lineLength = 80;
    const [editText, setEditText] = useState("");
    const {set} = useContext(FirebaseContext);
    const handleLocalizedTextChange: ChangeEventHandler<HTMLInputElement> = ({currentTarget}) => {
        setEditText(currentTarget.value);
    }
    const handleUpdateLocalizedTextClick = () =>
        set(`localization/${project}/${editLocalizedKey}/${language}`,
            {text: editText, timestamp: Date.now()}).catch(console.error).then(onClose);

    useEffect(() => {
        if (localizedText) {
            setEditText(localizedText);
        } else {
            setEditText("");
        }
    }, [localizedText]);
    return (
        <Dialog fullWidth open={Boolean(editLocalizedKey)} onClose={onClose}>
            <DialogTitle>Edit localized text</DialogTitle>
            <DialogContent dividers>
                <Box display="flex" flexDirection="column">
                    <TextField label="English text" multiline={englishText?.length > lineLength}
                               rows={englishText ? englishText.length / lineLength : 1} size="small" sx={{margin: 1}}
                               value={englishText || ""}/>
                    <TextField label={`Localized ${LocalizedLanguages[language]} text`}
                               multiline={editText?.length > lineLength}
                               rows={editText ? editText.length / lineLength : 1} onChange={handleLocalizedTextChange}
                               size="small" sx={{margin: 1}} value={editText}/>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Cancel</Button>
                <Button disabled={localizedText === editText} onClick={handleUpdateLocalizedTextClick} variant="contained">Update</Button>
            </DialogActions>
        </Dialog>
    );
}